import { ConnectDropTarget, useDrop } from 'react-dnd';
import { DateTime } from 'luxon';
import { itemTypes } from 'modules/dragAndDrop/itemTypes';
import { TimesheetLabel } from '../../../timesheet-labels/labelSchema';
import { NoteData } from '../../common';

interface UseNotesListItemDropProps {
  labelsToUpdate: TimesheetLabel[];
  onEditNote: (noteData: NoteData) => Promise<void>;
  groupIndex: string;
  day: string;
}

interface UseNotesListItemDropReturnProps {
  isOver: boolean;
  canDrop: boolean;
  dropRef: ConnectDropTarget;
}

export const useNotesListItemDrop = ({
  labelsToUpdate,
  onEditNote,
  groupIndex,
  day
}: UseNotesListItemDropProps): UseNotesListItemDropReturnProps => {
  const [{ isOver, canDrop }, dropRef] = useDrop(
    () => ({
      accept: itemTypes.NOTE_LIST_ITEM,
      drop: async ({ note }: any) => {
        await onEditNote({
          id: note.id,
          date: note.date ? DateTime.fromISO(note.date).toJSDate() : null,
          duration: note.duration ?? 0,
          classification: note.classification,
          startTime: note.startTime
            ? DateTime.fromISO(note.startTime).toJSDate()
            : null,
          endTime: note.endTime
            ? DateTime.fromISO(note.endTime).toJSDate()
            : null,
          note: note.description,
          timesheetLabels: labelsToUpdate
        });
      },
      canDrop: (item: any) => {
        return item.groupIndex !== groupIndex && item.day === day;
      },
      collect: (monitor) => {
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop()
        };
      }
    }),
    [labelsToUpdate]
  );

  return {
    isOver: isOver,
    canDrop: canDrop,
    dropRef: dropRef
  };
};
